import ParseApp from 'lib/ParseApp';
import React from 'react';
import PropTypes from 'prop-types';
import styles from 'components/Sidebar/Sidebar.scss';

export default class AppsSelector extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    }

    this.handleKey = this.handleKey.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  handleKey(e) {
    var keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.toggle(this);
        break;
    }
  }

  loadImage(el) {
    el.target.src = '/assets/images/default_app_icon.png';
  }

  toggle() {
    document.body.classList.toggle('open');

    if (this.state.open) {
      document.body.removeEventListener('keydown', this.handleKey);
      this.setState({ open: false });
    } else {
      document.body.addEventListener('keydown', this.handleKey);
      this.setState({ open: true });
    }
  }

  render() {
    let classes = [styles.currentApp, 'pg-currentApp-active'];

    return (
      <div className={styles.app}>
        <div className={classes.join(' ')} onClick={this.toggle.bind(this)}>
          <div className={styles.icon}>
            <img src={this.context.currentApp.icon ? this.context.currentApp.icon : '/assets/images/default_app_icon.png'} onError={this.loadImage.bind(this)} />
          </div>
          {this.context.currentApp.name}
        </div>
      </div>
    );
  }
}

AppsSelector.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
  activeItem: PropTypes.any
};
